import { path, httpService } from '@commons';

const args = { ...path, path: '/importar/ofx' };
const conciliacaoArgs = { ...path, path: '/conciliacao' };

// ======= UPLOAD ARQUIVO OFX =======
export function uploadOfx(payload) {
  return httpService.postFile({ ...args, args: '/upload' }, payload);
}

// ======= BUSCAR EXTRATOS OFX =======
export function buscarExtratosOfx(idPropriedade, idContaBanco, datas, where) {
  return httpService.get({ ...args, args: `/filter?propriedade=${idPropriedade}&datas=${datas}&contaBancoId=${idContaBanco}${where}` });
}

// ======= BUSCAR TRANSAÇÕES =======
export function buscarPendentes(filters, where) {
  const { contaBancoId, dataInicio, dataFim } = filters;
  const { tipoTransacao, page = 0, size = 10, historico } = where;

  const params = new URLSearchParams({
    contaBancoId,
    dataInicio,
    dataFim,
    page,
    size,
    ...(tipoTransacao && tipoTransacao !== 'TODOS' && { tipoTransacao }),
    ...(historico && { historico })
  });

  return httpService.get({ ...conciliacaoArgs, args: `/buscar-pendentes?${params.toString()}` });
}

export function buscarIgnoradas(filters, where) {
  const { contaBancoId, dataInicio, dataFim } = filters;
  const { tipoTransacao, page = 0, size = 10 } = where;

  const params = new URLSearchParams({
    contaBancoId,
    dataInicio,
    dataFim,
    page,
    size,
    ...(tipoTransacao && tipoTransacao !== 'TODOS' && { tipoTransacao })
  });

  return httpService.get({ ...conciliacaoArgs, args: `/buscar-ignoradas?${params.toString()}` });
}

export function buscarMovimentacoes(filters, where) {
  const { contaBancoId, dataInicio, dataFim } = filters;
  const { tipoTransacao, page = 0, size = 10 } = where;

  const params = new URLSearchParams({
    contaBancoId,
    dataInicio,
    dataFim,
    page,
    size,
    ...(tipoTransacao && tipoTransacao !== 'TODOS' && { tipoTransacao })
  });

  return httpService.get({ ...conciliacaoArgs, args: `/buscar-movimentacoes?${params.toString()}` });
}

// ======= AÇÕES DE LANÇAMENTOS =======
export function ignorarTransaction(id) {
  return httpService.put({ ...conciliacaoArgs, args: `/ignorar/${id}` });
}

export function restaurarTransaction(id) {
  return httpService.put({ ...conciliacaoArgs, args: `/restaurar/${id}` });
}

// ======= CONCILIAÇÃO =======
export function salvar(payload) {
  return httpService.post({ ...conciliacaoArgs, args: '/salvar' }, payload);
}

export function desconciliar(payload) {
  return httpService.post({ ...conciliacaoArgs, args: '/desconciliar' }, payload);
}

// ======= SALVAR CONCILIAÇÃO (LEGACY) =======
export function salvarConciliacao(payload) {
  return httpService.post({ ...conciliacaoArgs, args: '/salvar' }, payload);
}

// ======= BUSCAR LANÇAMENTOS PARA MODAL =======
export function buscarLancamentosBancoPendentes(contaBancoId, dataInicio, dataFim, page = 0, size = 10, tipoMovimento, historico) {
  const params = new URLSearchParams({
    contaBancoId,
    dataInicio,
    dataFim,
    page,
    size,
    ...(tipoMovimento && { tipoMovimento }),
    ...(historico && { historico })
  });
  return httpService.get({ ...path, path: `/lancamentoContaBanco/buscar-pendentes-conciliacao?${params}` });
}

export function buscarContasPagarPendentes(propriedadeId, dataInicio, dataFim, page = 0, size = 10, historico) {
  const params = new URLSearchParams({
    propriedadeId,
    dataInicio,
    dataFim,
    page,
    size,
    ...(historico && { historico })
  });
  return httpService.get({ ...path, path: `/contas/pagar/buscar-pendentes-conciliacao?${params}` });
}

export function buscarContasReceberPendentes(propriedadeId, dataInicio, dataFim, page = 0, size = 10, historico) {
  const params = new URLSearchParams({
    propriedadeId,
    dataInicio,
    dataFim,
    page,
    size,
    ...(historico && { historico })
  });
  return httpService.get({ ...path, path: `/contas/receber/buscar-pendentes-conciliacao?${params}` });
}

export function buscarContasRecorrentesPendentes(propriedadeId, dataInicio, dataFim, page = 0, size = 10) {
  const datas = `${dataInicio.split('-').reverse().join('/')}_${dataFim.split('-').reverse().join('/')}`;
  return httpService.get({ ...path, path: `/contas/recorrente/pagar?propriedade=${propriedadeId}&datas=${datas}&page=${page}&size=${size}` });
}

export function gerarContaAgoraConciliacao(id) {
  return httpService.put({ ...path, path: `/contas/recorrente/pagar/gerarContaAgora/${id}` });
}

// ======= RESUMO CONCILIAÇÃO =======
export function buscarResumoConciliacao(contaBancoId) {
  return httpService.get({ ...conciliacaoArgs, args: `/resumo-conciliacao?contaBancoId=${contaBancoId}` });
}

// ======= EXPORT PRINCIPAL =======
export const conciliacaoBancariaService = {
  uploadOfx,
  buscarPendentes,
  buscarIgnoradas,
  buscarMovimentacoes,
  ignorarTransaction,
  restaurarTransaction,
  salvar,
  desconciliar,
  salvarConciliacao,
  buscarLancamentosBancoPendentes,
  buscarContasPagarPendentes,
  buscarContasReceberPendentes,
  buscarContasRecorrentesPendentes,
  gerarContaAgoraConciliacao,
  buscarResumoConciliacao
};